import { SxProps, Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import { commonStyles } from '~/theme/styles/commonStyles';

type Styles = {
  container: (margin: number) => SxProps<Theme>;
  root: SxProps<Theme>;
  paper: SxProps<Theme>;
  overlay: SxProps<Theme>;
  titleBar: (
    theme: Theme,
    isMobile?: boolean,
    isTablet?: boolean,
    isOpened?: boolean
  ) => SystemStyleObject<Theme>;
  formContainer: SxProps<Theme>;
  divider: SxProps<Theme>;
  modalContainer: SxProps<Theme>;
  checkboxContainer: SxProps<Theme>;
  testEnvironmentButton: SxProps<Theme>;
  titleForm: SxProps<Theme>;
  border: SxProps<Theme>;
  managersContainer: SxProps<Theme>;
};

export const styles: Styles = {
  root: (theme: Theme) => ({
    position: 'relative',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'flex-start',
    background: theme.palette.background.paper,
    letterSpacing: '-1px',
  }),
  divider: (theme: Theme) => ({
    background: theme.palette.grey[100],
    border: 'none',
    height: 2,
  }),
  formContainer: (theme: Theme) => ({
    background: theme.palette.background.default,
    border: `1px solid ${theme.palette.grey.additionalGrey}`,
    padding: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2.5),
    },
  }),
  container: (margin: number) => (theme: Theme) => ({
    width: `calc(100% - ${margin}px - 64px)`,
    padding: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
  }),
  paper: (theme: Theme) => ({
    padding: 5,
    background: theme.palette.common.white,
    borderRadius: theme.spacing(1.5),
    mt: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3),
    },
  }),
  overlay: (theme: Theme) => ({
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      background: theme.palette.common.black,
      zIndex: 200,
      opacity: 0.1,
    },
  }),
  titleBar: (theme: Theme, isMobile?: boolean, isTablet?: boolean, isOpened?: boolean) => ({
    textAlign: 'center',
    padding: theme.spacing(3, 2, 2, 0),
    marginLeft: '300px',
    fontSize: '16px',
    background: theme.palette.background.paper,
    color: theme.palette.primary.main,
    [theme.breakpoints.down('md')]: {
      marginLeft: isTablet && !isOpened ? '100px' : '300px',
      fontSize: '14px',
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: isMobile && !isOpened ? 0 : '50px',
      fontSize: '12px',
    },
  }),
  modalContainer: (theme: Theme) => ({
    width: '450px',
    p: theme.spacing(4),
    position: 'relative',
  }),
  checkboxContainer: (theme: Theme) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: theme.spacing(5),
  }),
  testEnvironmentButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    height: '35px',
    paddingBottom: '10px',
  },
  titleForm: {
    textAlign: 'center',
    paddingBottom: 2,
  },
  border: (theme: Theme) => ({
    border: `2px solid`,
    borderColor: theme.palette.grey[100],
    borderRadius: 1,
    padding: 3,
  }),
  managersContainer: {
    ...commonStyles.columnFlexContainer,
    gap: 1,
    width: '100%',
    alignItems: 'flex-end',
  },
};
